;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import GroupCard from "./index"

type GroupLike = { city?: string } & Record<string, unknown>

// Maps group data to the spacer-wrapped <GroupCard> elements a carousel renders.
// Called from server components (home MiddleSection, landing pages) so the card
// DOM is server-rendered with no per-card hydration; GroupCard is a shared
// component, so client callers (empty-search state) still work.
export default function renderGroupCards(
  groups: ReadonlyArray<GroupLike>,
  { isFirstRow = false }: { isFirstRow?: boolean } = {},
) {
  return groups.map((group, cardIndex) => (
    <div
      className="mr-6 snap-start min-[760px]:mr-[36px]"
      key={`group-card-${group.city}-${cardIndex}`}
    >
      <GroupCard
        // group is a GraphQL node carrying all GroupCard fields; spread loosely
        // (GroupCard is an untyped JS component).
        {...(group as any)}
        index={cardIndex}
        priority={isFirstRow && cardIndex < 3}
      />
    </div>
  ))
}
